var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.997 16H40C35.5817 16 32 19.5817 32 24V136C32 140.418 35.5817 144 40 144H123V139H128V26.0034L123 21.0034V139H40C38.3431 139 37 137.657 37 136V24C37 22.3431 38.3431 21 40 21H122.997L117.997 16ZM48 36H112V41H48V36ZM112 51.6025H48V56.6025H112V51.6025ZM76 67.2168H112V72.2168H76V67.2168ZM107.672 101.912C107.408 96.9839 103.668 95.0039 99.0041 95.0039C94.2961 95.0039 90.9081 97.0279 90.9081 100.328C90.9081 103.584 93.6801 104.772 97.9481 105.74L101.248 106.488C107.232 107.852 111.324 109.92 111.324 115.376C111.324 120.48 107.408 123.956 100.676 124.44V129.192H97.2001V124.396C90.6001 123.868 86.2441 120.348 85.4961 114.628V113.968H89.3681C89.9841 119.336 94.1201 121.316 99.0481 121.316C103.932 121.316 107.32 119.336 107.32 115.684C107.32 111.988 104.284 110.976 99.9721 110.008L96.6721 109.26C90.6881 107.896 86.9041 105.564 86.9041 100.46C86.9041 95.7079 90.8201 92.3639 97.3761 91.8799V87.1279H100.852V91.9239C107.188 92.4959 111.016 95.9279 111.544 101.252V101.912H107.672Z",
    fill: "#DEDAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoices);
export default __webpack_public_path__ + "static/media/noInvoices.9264e91186b5e7b815a72e62c02747c3.svg";
export { ForwardRef as ReactComponent };